/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query CBRRoutePlanReadQuery($routeId: ID!, $mccNameToSearch: String, $mncNameToSearch: String, $operatorNameToSearch: String, $countryNameToSearch: String, $take: PositiveInt, $skip: Int) {
    CBRRoutePlanRead(routeId: $routeId, mccNameToSearch: $mccNameToSearch, mncNameToSearch: $mncNameToSearch, operatorNameToSearch: $operatorNameToSearch, countryNameToSearch :$countryNameToSearch,take: $take, skip: $skip) {
      id
      createdAt
      updatedAt
      message
      status,
      _totalCount,
      VendorAccount {
        id,
        displayName
      },
      Mcc {
        createdAt,
        updatedAt,
        mcc,
        countryName,
        dialingCode
      },
      Mnc {
        createdAt,
        updatedAt,
        mnc,
        network
      }
      CBRRoute {
        id
        displayName
      }
    }
  }
`
